<article
  class="notification-card"
  [class.notification-card--unread]="!item.read"
  [class.notification-card--critical]="item.priority === 'critical'"
  [class.notification-card--navbar]="variant === 'navbar'"
  (click)="onCardClick()">

  <div class="notification-card__icon" [attr.data-category]="item.category">
    <i class="feather" [ngClass]="'icon-' + categoryIconName"></i>
  </div>

  <div class="notification-card__content">
    <div class="notification-card__title-row">
      <h3 class="notification-card__title" [title]="item.title">{{ item.title }}</h3>
      <span class="notification-card__time">{{ relativeTimeLabel }}</span>
    </div>

    <div class="notification-card__meta">
      <span class="notification-card__category">{{ categoryLabel }}</span>
      <span class="notification-card__priority" [attr.data-priority]="item.priority">{{ priorityLabel }}</span>
    </div>

    <app-notification-message
      [body]="item.body"
      [maxLines]="maxMessageLines"
      [messageId]="'msg-' + item.id"
      [(expanded)]="messageExpanded">
    </app-notification-message>

    <div class="notification-card__attachments" *ngIf="hasAttachments" (click)="$event.stopPropagation()">
      <div class="notification-card__attachments-label">
        <i class="feather icon-paperclip"></i> Attachment
      </div>
      <div class="notification-card__attachments-grid"
        [class.notification-card__attachments-grid--single]="attachments.length === 1">
        <app-notification-attachment-card
          *ngFor="let att of attachments"
          [attachment]="att"
          (preview)="onPreviewAttachment($event)"
          (download)="onDownloadAttachment($event)">
        </app-notification-attachment-card>
      </div>
    </div>
  </div>

  <div class="notification-card__status">
    <span class="notification-card__dot" *ngIf="!item.read" title="Unread"></span>
    <button type="button" class="notification-card__mark-read" *ngIf="!item.read"
      (click)="onMarkRead($event)" title="Mark as read" aria-label="Mark as read">
      <i class="feather icon-check"></i>
    </button>
  </div>
</article>
